module.exports = __webpack_public_path__ + "static/media/airbnbLogo.5e92ece1.png";